import { createTableFiltersStore } from "./createTableFiltersStore";

export interface PaymentGatewayEventListFiltersState extends Record<
  string,
  unknown
> {
  /** A WIC-PAY code or the gateway's own code. */
  search: string;
}

const defaults: PaymentGatewayEventListFiltersState = {
  search: "",
};

export const usePaymentGatewayEventFiltersStore =
  createTableFiltersStore<PaymentGatewayEventListFiltersState>({
    name: "admin.paymentGatewayEvents.filters",
    version: 1,
    defaults,
    defaultPageSize: 20,
  });
